export interface GeoPosition {
    lat: number;
    lng: number;
}

export function createGeoPosition(lat: number, lng: number) {
    return { lat, lng } as GeoPosition;
}

export function getCurrentPosition(options?: PositionOptions): Promise<GeolocationPosition> {
    return new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject, options);
    });
}
